import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

export const getReviewerStatuses = (rows: {status: ChangeRequestStatus}[]) => {
    const statuses = rows.map(({status}) => status);

    return [
        ...(statuses.includes(ChangeRequestStatus.WAITING_REVIEW) ? [ChangeRequestStatus.WAITING_REVIEW] : []),
        ...(statuses.includes(ChangeRequestStatus.REOPENED) ? [ChangeRequestStatus.REOPENED] : []),
        ...(statuses.includes(ChangeRequestStatus.IN_REVIEW) ? [ChangeRequestStatus.IN_REVIEW] : []),
    ];
};
